// generated from 2 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const totalRevenueFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("total_revenue_filter"),
  // Constants::Comparisons.numerical_field_comparisons: more than / less than / exactly.
  comparison_key: z.enum(["1", "3", "5"]),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on (FilterJsonFormatter#filter_as_json).
  raw_value: z.int().optional(),
  // Any integer (soft_strict_value_field Integer); the handful of samples all happened to be 0.
  value: z.int(),
  varies_by_app_group: z.literal(false),
});
